<template>
  <loading-rating-bar v-if="panelLoading" />
  <view-rating-percentage
    v-else
    :percentage="ratings?.percentage"
    :text="ratings?.text"
  />
</template>

<script>
import ViewRatingPercentage from '@components/Mod/ViewRatingPercentage.vue'
import LoadingRatingBar from '@components/Loading/LoadingRatingBar.vue'
import { computed, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'

export default {
  components: {
    ViewRatingPercentage,
    LoadingRatingBar,
  },
  props: {
    mod: {
      type: Object,
      default: () => ({}),
    },
    panelLoading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { mod } = toRefs(props)
    const { t } = useI18n()

    const ratings = computed(() => {
      return (
        mod.value && {
          text: t(
            mod.value.stats.ratings_display_text
              .toLowerCase()
              .replace(/ /g, '_')
          ),
          percentage: mod.value.stats.ratings_percentage_positive,
        }
      )
    })

    return { ratings }
  },
}
</script>
